// @flow

export function isElementVisible(element: HTMLElement): boolean {
  return element.offsetParent !== null;
}
